module.exports = __webpack_public_path__ + "static/media/kanban.5d479ae5.svg";